import { computed, Directive, input } from '@angular/core';
import { TuiSizeS } from '@taiga-ui/core';

export type CellColorCode = 'green' | 'yellow' | 'red' | 'gray';

@Directive()
export class ColorCodeCellBase<T = string | number | null> {
	readonly value = input.required<T>();
	readonly size = input<TuiSizeS>('s');

	/**
	 * override to format the value however is needed based on the inheriting class
	 */
	readonly formattedValue = computed<string | null>(() =>
		String(this.value()),
	);

	readonly colorClass = computed(() => {
		const size = this.size();
		const classList = ['rounded-full'];
		switch (size) {
			case 'm':
				classList.push('size-6');
				break;
			case 's':
			default:
				classList.push('size-2');
				break;
		}

		const value = this.value();
		classList.push(`bg-${this.getColorCode(value)}-500`);

		return classList.join(' ');
	});

	getColorCode(_: T): CellColorCode {
		console.warn('This function should be overridden in the inheritance');
		return 'red';
	}
}
